import { put, takeLatest } from "redux-saga/effects";
import {
  requestCreateSmartProposal,
  requestDeleteSmartProposal,
  requestForArchive,
  requestSmartProposal,
  requestUpdateSmartProposal,
  requestForBookMark,
  requestProposalActivity,
  requestForDelete,
  requestForAddNotes,
  requestForUpdateProposal,
  requestCreateSendDraftProposal,
  requsetForContactList,
  requsetForContactList1,
  requestForUploadDocumentForProposal,
  requestForPublicUrl,
  requestSmartProposalReport,
  requestRemoveDocument,
  requestForProposalDownload,
} from "./../../../services/sales-pipeline/smartProposal";
import {
  createSmartProposalFailure,
  createSmartProposalRequest,
  createSmartProposalSuccess,
  fetchSmartProposalListFailure,
  fetchSmartProposalListRequest,
  fetchSmartProposalListSuccess,

  fetchAllSmartProposalListFailure,
  fetchAllSmartProposalListRequest,
  fetchAllSmartProposalListSuccess,

  updateSmartProposalFailure,
  updateSmartProposalSuccess,
  updateSmartProposalRequest,
  archiveSmartProposalFailure,
  archiveSmartProposalRequest,
  archiveSmartProposalSuccess,
  deleteSmartProposalSuccess,
  deleteSmartProposalFailure,
  deleteSmartProposalRequest,
  bookmarkSmartProposalFailure,
  bookmarkSmartProposalSuccess,
  bookmarkSmartProposalRequest,
  createSendDraftProposalRequest,
  createSendDraftProposalSuccess,
  createSendDraftProposalFailure,
  fetchProposalActivityListFailure,
  fetchProposalActivityListRequest,
  fetchProposalActivityListSuccess,
  addNotesForProposalFailure,
  addNotesForProposalRequest,
  addNotesForProposalSuccess,
  updateDetailProposalFailure,
  updateDetailProposalRequest,
  updateDetailProposalSuccess,
  getContactlistFailure,
  getContactlistRequest,
  getContactlistSuccess,



  getContactlistFailure1,
  getContactlistRequest1,
  getContactlistSuccess1,
  fetchSmartProposalReportRequest,
  fetchSmartProposalReportSuccess,
  fetchSmartProposalReportFailure,
  uploadDocumentForProposalRequest,
  uploadDocumentForProposalSuccess,
  uploadDocumentForProposalFailure,
  publicLinkForProposalFailure,
  publicLinkForProposalRequest,
  publicLinkForProposalSuccess,
  removeDocumentForProposalFailure,
  removeDocumentForProposalRequest,
  removeDocumentForProposalSuccess,
  downloadProposalFailure,
  downloadProposalRequest,
  downloadProposalSuccess,
} from "../../reducers/smart-proposal";

export function* watchSmartProposalSaga() {
  yield takeLatest(fetchSmartProposalListRequest, fetchSmartProposalList);
  yield takeLatest(fetchAllSmartProposalListRequest, fetchAllSmartProposalList);
  yield takeLatest(createSmartProposalRequest, createSmartProposal);
  yield takeLatest(updateSmartProposalRequest, updateSmartProposal);
  yield takeLatest(archiveSmartProposalRequest, archiveSmartProposal);
  yield takeLatest(deleteSmartProposalRequest, deleteSmartProposal);
  yield takeLatest(bookmarkSmartProposalRequest, bookmarkSmartProposal);
  yield takeLatest(createSendDraftProposalRequest, sendDraftProposal);
  yield takeLatest(fetchProposalActivityListRequest, fetchProposalActivity);
  yield takeLatest(uploadDocumentForProposalRequest, uploadDocumentRequest);
  yield takeLatest(addNotesForProposalRequest, addNoteProposal);
  yield takeLatest(updateDetailProposalRequest, updateDetailProposal);
  yield takeLatest(getContactlistRequest, contactList);
  yield takeLatest(getContactlistRequest1, contactList1);
  yield takeLatest(fetchSmartProposalReportRequest, proposalReport);
  yield takeLatest(publicLinkForProposalRequest, getPublicLink);
  yield takeLatest(removeDocumentForProposalRequest, removeDocument);
  yield takeLatest(downloadProposalRequest, downloadProposal);
}

/**
 * @typedef {Object} PAYLOAD
 * @property {number} skip
 *
 * @typedef {Object} PARAMS
 * @property {PAYLOAD} payload
 *
 */

/**
 *
 * @param {PARAMS} param0
 */
function* fetchSmartProposalList({ payload }) {
  try {
    const response = yield requestSmartProposal(payload);
    yield put(fetchSmartProposalListSuccess(response));
  } catch (error) {
    yield put(
      fetchSmartProposalListFailure("Failed to get list of smart proposal")
    );
  }
}
function* fetchAllSmartProposalList({ payload }) {
  try {
    const response = yield requestSmartProposal(payload);
    if(!payload.cancelRequest){
      yield put(fetchAllSmartProposalListSuccess(response));
    }
  } catch (error) {
    yield put(
      fetchAllSmartProposalListFailure("Failed to get list of smart proposal")
    );
  }
}

/**
 *
 * @param {SmartProposalState} param0
 */
function* createSmartProposal({ payload }) {
  try {
    const response = yield requestCreateSmartProposal(payload);
    yield put(createSmartProposalSuccess(response.data));
  } catch (error) {
    yield put(createSmartProposalFailure("Failed to get list of Leads"));
  }
}

/**
 *
 * @param {SmartProposalState} param0
 */
function* updateSmartProposal({ payload }) {
  try {
    const response = yield requestUpdateSmartProposal(payload);
    yield put(updateSmartProposalSuccess(response.data));
  } catch (error) {
    yield put(updateSmartProposalFailure("Failed to get list of Leads"));
  }
}

/**
 *
 * @param {LeadForm} param0
 */
function* archiveSmartProposal({ payload }) {
  try {
    const response = yield requestForArchive(payload);
    yield put(archiveSmartProposalSuccess(response.data));
  } catch (error) {
    yield put(archiveSmartProposalFailure("Failed to archive list of Leads"));
  }
}

/**
 *
 * @param {LeadForm} param0
 */
function* deleteSmartProposal({ payload }) {
  try {
    const response = yield requestForDelete(payload);
    yield put(deleteSmartProposalSuccess(response.data));
  } catch (error) {
    yield put(deleteSmartProposalFailure("Failed to delete of smart proposal"));
  }
}

/**
 *
 * @param {SmartProposalState} param0
 */
function* bookmarkSmartProposal({ payload }) {
  try {
    const response = yield requestForBookMark(payload);
    yield put(bookmarkSmartProposalSuccess(response.data));
  } catch (error) {
    yield put(
      bookmarkSmartProposalFailure("Failed to bookmark of smart proposal")
    );
  }
}

/**
 *
 * @param {SmartProposalState} param0
 */
function* fetchProposalActivity({ payload }) {
  try {
    const response = yield requestProposalActivity(payload);
    yield put(fetchProposalActivityListSuccess(response.data));
  } catch (error) {
    yield put(
      fetchProposalActivityListFailure(
        "Failed to get proposal activity of smart proposal"
      )
    );
  }
}

/**
 *
 * @param {sendDraftProposal} param0
 */
function* sendDraftProposal({ payload }) {
  try {
    const response = yield requestCreateSendDraftProposal(payload);
    yield put(createSendDraftProposalSuccess(response.data));
  } catch (error) {
    yield put(createSendDraftProposalFailure("Failed to get Data"));
  }
}

/**
 *
 * @param {sendDraftProposal} param0
 */
function* addNoteProposal({ payload }) {
  try {
    const response = yield requestForAddNotes(payload);
    yield put(addNotesForProposalSuccess(response.data));
  } catch (error) {
    yield put(addNotesForProposalFailure("Failed to get Data"));
  }
}

/**
 *
 * @param {sendDraftProposal} param0
 */
 function* updateDetailProposal({ payload }) {
  try {
    const response = yield requestForUpdateProposal(payload);
    yield put(updateDetailProposalSuccess(response.data));
  } catch (error) {
    yield put(updateDetailProposalFailure("Failed to get Data"));
  }
}

/**
 *
 * @param {sendDraftProposal} param0
 */
function* contactList({ payload }) {
  try {
    const response = yield requsetForContactList(payload);
    yield put(getContactlistSuccess(response.data));
  } catch (error) {
    yield put(getContactlistFailure("Failed to get Data"));
  }
}
function* contactList1({ payload }) {
  try {
    const response = yield requsetForContactList1(payload);
    yield put(getContactlistSuccess1(response.data));
  } catch (error) {
    yield put(getContactlistFailure1("Failed to get Data"));
  }
}


function* proposalReport({ payload }) {
  try {
    const response = yield requestSmartProposalReport(payload);
    yield put(fetchSmartProposalReportSuccess(response));
  } catch (error) {
    yield put(
      fetchSmartProposalReportFailure(
        "Failed to get list of smart proposal Report"
      )
    );
  }
}

/**
 *
 * @param { uploadDocument } param0
 */
function* uploadDocumentRequest({ payload }) {
  try {
    const response = yield requestForUploadDocumentForProposal(payload);
    yield put(uploadDocumentForProposalSuccess(response.data));
  } catch (error) {
    yield put(uploadDocumentForProposalFailure("Failed to Upload document"));
  }
}

/**
 *
 * @param { uploadDocument } param0
 */
function* getPublicLink({ payload }) {
  try {
    const response = yield requestForPublicUrl(payload);
    yield put(publicLinkForProposalSuccess(response.data));
  } catch (error) {
    yield put(publicLinkForProposalFailure("Failed to get link"));
  }
}

/**
 *
 * @param { removeDocument
 } param0
 */
function* removeDocument({ payload }) {
  try {
    const response = yield requestRemoveDocument(payload);
    yield put(removeDocumentForProposalSuccess(response.data));
  } catch (error) {
    yield put(removeDocumentForProposalFailure("Failed to remove document"));
  }
}

/**
 *
 * @param { removeDocument
 } param0
 */
function* downloadProposal({ payload }) {
  try {
    const response = yield requestForProposalDownload(payload);
    yield put(downloadProposalSuccess(response.data));
  } catch (error) {
    yield put(downloadProposalFailure("Failed to download document"));
  }
}
